import useCallAxios from "./useCallAxios";
import api from "../Services/api";

/**
 * Confirms an IB peer internal transfer (Valut ↔ Valut) via MobileService
 * `POST /v1/ib/transfers` → BaaS Contas internal-transfers (status completed).
 * Same progress-result shape as `confirmPixTransfer` for `runWithProgress`.
 */
export const confirmInternalTransfer = async (body) => {
  try {
    const res = await api.post("/v1/ib/transfers", body);
    const data = res.data?.data ?? res.data;
    const status = String(data?.status || "").toLowerCase();

    if (status && status !== "completed" && status !== "success") {
      return {
        success: false,
        message: "Transferência pendente",
        description:
          "A transferência foi aceita, mas ainda não está concluída. Acompanhe no extrato.",
        data,
      };
    }

    return {
      success: true,
      data,
      message: "Transferência concluída",
      description: "Entre contas Valut.",
    };
  } catch (err) {
    const payload = err.response?.data;
    return {
      success: false,
      message:
        payload?.information ||
        payload?.title ||
        payload?.detail ||
        "Falha na transferência",
      description:
        payload?.description ||
        payload?.detail ||
        "Não foi possível concluir a transferência. Tente novamente.",
      error: payload?.error,
    };
  }
};

export const useTransferTransaction = () => {
  const context = `transactionPay`;
  const {
    requestSuccess,
    requestData,
    requestLoading,
    fetchPOST,
    requestMessage,
    reset,
  } = useCallAxios({
    context,
  });

  const handlePOST = (params) => {
    return fetchPOST({ body: params });
  };

  return {
    loading: requestLoading,
    message: requestMessage,
    state: requestData.data,
    success: requestSuccess,
    handlePOST,
    reset,
  };
};
